import React from 'react';

import { SitePermissionsPageLoader } from '@confluence/confluence-analytics/entry-points/SitePermissionsPage';
import { ADMIN_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs';

export const SiteAnalyticsPermissionsRoute = () => {
	return <SitePermissionsPageLoader />;
};

SiteAnalyticsPermissionsRoute.NAVIGATION_PARAMS = () => ({
	Screen: {
		screenEvent: { name: 'instanceAnalyticsPermissions' },
	},
	MainLayout: {
		navView: ADMIN_HOME_ID,
	},
});
